import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import {
  LiveTvOutlined,
  CheckCircleOutlineOutlined,
  ScheduleOutlined,
} from "@mui/icons-material";
import StatsCard from "./StatsCard";
import apiService from "../../../service/Api";

interface BookingStats {
  total: number;
  enquiry: number;
  confirmed: number;
  fulfilled: number;
  cancelled: number;
  lost: number;
  testing: number;
}

const StatsSection: React.FC = () => {
  const [stats, setStats] = useState<BookingStats>({
    total: 0,
    enquiry: 0,
    confirmed: 0,
    fulfilled: 0,
    cancelled: 0,
    lost: 0,
    testing: 0,
  });

  const fetchStats = useCallback(async () => {
    try {
      const response = await apiService.get<BookingStats>(
        `/api/bookings/booking/statistics/`,
      );
      setStats(response.data);
    } catch (error) {
      console.error("Failed to fetch booking statistics:", error);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
      <StatsCard
        title="Total Bookings"
        value={stats.total}
        icon={<LiveTvOutlined />}
        backgroundColor="#4285F4"
      />
      <StatsCard
        title="Bookings Completed"
        value={stats.fulfilled}
        icon={<CheckCircleOutlineOutlined />}
        backgroundColor="#34A853"
      />
      <StatsCard
        title="Bookings Cancelled"
        value={stats.cancelled}
        icon={<ScheduleOutlined />}
        backgroundColor="#f2bcbc"
      />
    </Box>
  );
};

export default StatsSection;
